import { css, styled } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import { abbreviatedNumber } from 'src/pages/Yearbooks/presentation/components/Charts/utils';

interface ColumnChartProps {
  data: {
    name: string;
    data: number[];
  }[];
  stacked?: boolean;
  numeric?: boolean;
  monetary?: boolean;
  animationEnabled?: boolean;
  categories: string[];
  height?: number;
  formatter?: (value: number) => string;
}

export default function ColumnChart(props: ColumnChartProps) {
  const StyledChart = styled(ReactApexChart)`
    width: 100%;
    ${({ theme }) => css`
      width: ${theme.breakpoints.values.sm}px;

      @media (max-width: ${theme.breakpoints.values.md}px) {
        width: ${theme.breakpoints.values.sm}px;
      }

      @media (max-width: ${theme.breakpoints.values.sm}px) {
        width: 100%;
      }
    `}
  `;

  return (
    <StyledChart
      type="bar"
      series={props.data}
      options={{
        chart: {
          stacked: props.stacked ?? true,
          stackType: '100%',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: props.animationEnabled ?? true,
          },
        },
        tooltip: {
          y: {
            formatter: props.formatter
              ? props.formatter
              : function (value: any) {
                  if (isNaN(Number(value))) {
                    return value;
                  }

                  if (props.stacked || props.numeric) {
                    const formatedNumber = abbreviatedNumber(value);
                    const isMonetary = props.monetary ?? true;

                    return `${isMonetary ? 'R$' : ''} ${formatedNumber}`;
                  }

                  const formatedNumber = Number(value).toLocaleString('pt-BR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  });

                  return `${formatedNumber} %`;
                },
          },
        },

        colors: [
          '#FD841F',
          '#CD104D',
          '#F2CD5C',
          '#600446',
          '#35D0BA',
          '#A61F69',
        ],
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        grid: {
          show: false,
        },
        xaxis: {
          categories: props.categories,
          type: 'category',
          labels: {
            show: props.categories.length <= 6 ? true : false,
            style: {
              fontWeight: 'bold',
              colors: 'white',
            },
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        responsive: [
          {
            breakpoint: 1000,
            options: {
              plotOptions: {
                bar: {
                  borderRadiusWhenStacked: 'last',
                  borderRadiusApplication: 'end',
                  rangeBarGroupRows: true,
                },
              },
              chart: {
                animations: {
                  enabled: false,
                },
              },
            },
          },
        ],
      }}
    />
  );
}
